import { Banner } from '@evisort/eds/components/Banner/Banner';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { selectPageBanner } from '~/redux/slices/pages';
import { RootState } from '~/redux/types';

export function AppPageBanner() {
  const { pathname } = useLocation();
  const banner = useSelector((state: RootState) =>
    selectPageBanner(state, pathname),
  );

  if (!banner) {
    return null;
  }

  return <Banner {...banner} />;
}
